import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { inventarioService } from '../../services';

export const InventariosFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Inventário"
      service={inventarioService}
      redirectPath="/admin/estoque/inventarios"
      fields={[
        { name: 'itens', label: '', render: () => null },
        { name: 'observacao', label: 'Observação', type: 'textarea' },
        // Note: itens array would need custom handling with barcode scanner
      ]}
      initialValues={{ itens: [] }}
    />
  );
};
